import { create } from 'zustand';

const reactionStore = create((set, get) => ({
  selectedItems: null,

  // Stocke l'item sélectionné
  setSelectedItems: (items) => set({ selectedItems: items }),

  // Une fonction générique à appeler depuis le popup (tu peux la changer ou l'étendre)
  // On stocke une fonction externe (ex: handleAction de FullPagePC)
  registeredHandler: null,
  registerHandler: (fn) => set({ registeredHandler: fn }),

  // Appel depuis n'importe où
  triggerHandler: () => {
    const { selectedItems, registeredHandler } = get();

    if (selectedItems && typeof registeredHandler === 'function') {
      registeredHandler(selectedItems);
    }
  },




}));

export default reactionStore;
